const map = {
  skipFont: ({ theme }) => theme.fonts.set(`primary`, `bold`),
  skipForeground: ({ theme }) => theme.colors.black,
  skipBackground: ({ theme }) => theme.colors.hjortron,
}

export default map
